import React, { useEffect, useState } from 'react';
import { List } from '@tink/core/src/components/atoms/List/List';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { captureMessage } from '@tink/core/src/sentry';
import { LineItem } from '../../../atoms/LineItem/LineItem';
import { ProviderField } from '../../../../models/provider';
import { Text } from '../../../atoms/Text/Text';

type Props = {
  field: ProviderField;
  renderDescription?: boolean;
};

export const TemplateOrderedList: React.FC<Props> = ({ field, renderDescription = true }) => {
  const [listItems, setListItems] = useState<string[]>([]);
  const { description, value } = field;

  useEffect(() => {
    if (!value) {
      return;
    }

    try {
      setListItems(JSON.parse(value));
    } catch (err) {
      captureMessage(`TemplateOrderedList has malformed "value"`);
    }
  }, [value]);

  if (!description || !value) return null;

  return (
    <div data-testid="ordered-list-template">
      {renderDescription && (
        <Box mb="xxsmall">
          <Text>{description}</Text>
        </Box>
      )}
      {listItems.length > 0 && (
        <List as="ol">
          {listItems.map((txt, i) => (
            <LineItem index={i + 1} key={txt}>
              {txt}
            </LineItem>
          ))}
        </List>
      )}
    </div>
  );
};
